import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import ModernSidebar from './ModernSidebar';
import ModernNavbar from './ModernNavbar';

const DRAWER_WIDTH = 260;
const DRAWER_WIDTH_COLLAPSED = 70;
const NAVBAR_HEIGHT = 56;

// COMPLETELY REWRITTEN: Use absolute positioning to bypass flex constraints
const MainContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCollapsed' && prop !== 'isMobile',
})(({ theme, isCollapsed, isMobile }) => ({
  position: 'fixed',
  top: `${NAVBAR_HEIGHT}px`,
  left: isMobile ? 0 : (isCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH),
  right: 0,
  bottom: 0,
  overflow: 'auto',
  backgroundColor: theme.palette.background.default,
  transition: theme.transitions.create(['left'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

const LayoutWrapper = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isCollapsed, setIsCollapsed] = useState(isMobile);

  const toggleSidebar = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    
    // Store in localStorage for persistence
    localStorage.setItem('sidebarCollapsed', newState.toString());
    
    // Emit custom event for pages to listen to
    window.dispatchEvent(new CustomEvent('sidebarToggle', { 
      detail: { collapsed: newState } 
    }));
  };

  // DIAGNOSTIC LOGGING
  console.log('=== LAYOUTWRAPPER RENDER ===');
  console.log('isMobile:', isMobile);
  console.log('isCollapsed:', isCollapsed);
  console.log('DRAWER_WIDTH:', DRAWER_WIDTH);
  console.log('DRAWER_WIDTH_COLLAPSED:', DRAWER_WIDTH_COLLAPSED);
  console.log('NAVBAR_HEIGHT:', NAVBAR_HEIGHT);
  console.log('MainContent left:', isMobile ? 0 : (isCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH), 'px');

  return (
    <>
      {/* Sidebar */}
      <ModernSidebar
        isCollapsed={isCollapsed}
        toggleSidebar={toggleSidebar}
        onClose={() => isMobile && setIsCollapsed(true)}
        variant={isMobile ? 'temporary' : 'permanent'}
      />

      {/* Navbar */}
      <ModernNavbar
        isCollapsed={isCollapsed}
        toggleSidebar={toggleSidebar}
      />

      {/* Main Content Area - Now using fixed positioning */}
      <MainContent 
        isCollapsed={isCollapsed} 
        isMobile={isMobile}
        className="modern-main-content"
        ref={(el) => {
          if (el) {
            console.log('=== MAINCONTENT ACTUAL STYLES (NEW LAYOUT) ===');
            const computed = window.getComputedStyle(el);
            console.log('position:', computed.position);
            console.log('left:', computed.left);
            console.log('right:', computed.right);
            console.log('top:', computed.top);
            console.log('bottom:', computed.bottom);
            console.log('width:', computed.width);
            const rect = el.getBoundingClientRect();
            console.log('Actual rendered width:', rect.width);
            console.log('Actual left position:', rect.left);
          }
        }}
      >
        {children}
      </MainContent>
    </>
  );
};

export default LayoutWrapper;
